import { OutcomePublic } from "#models/outcome";
import { Product } from "#models/product";
import { CompleteQuestionnaireParam, Lead, QuestionnaireDetails, QuestionnaireTheme } from "#models/questionnaire";
import axios from 'axios';
import API from './http';

export const getQuestionnaireDetailsById = (id: string): Promise<QuestionnaireDetails> => {
  return API.get(`/api/Assessments/public/Questionnaire/${id}`).then((res) => res.data);
};

export const getQuestionnaireDetailsBySlug = (slug: string): Promise<QuestionnaireDetails> => {
  return API.get(`/api/Assessments/public/Questionnaire/slug/${slug}`).then((res) => res.data);
};

export const getQuestionnaireDetailsPreview = (id: string): Promise<QuestionnaireDetails> => {
  return API.get(`/api/Assessments/public/Questionnaire/preview/${id}`).then((res) => res.data);
};

export const getThemeById = (id: string): Promise<QuestionnaireTheme> =>
  API.get(`/api/assessments/public/theme/${id}`).then((res) => res.data);

export const getThemeByQuestionnaireId = (id: string): Promise<QuestionnaireTheme> =>
  API.get(`/api/assessments/public/theme/questionnaire/${id}`).then((res) => res.data);

export const completeQuestionnaire = (params: CompleteQuestionnaireParam) =>
  API.post('/api/Assessments/public/CompletedQuestionnaire', params).then((res) => res.data);

export const getOutcomePublic = (id: string): Promise<OutcomePublic> => {
  return API.get(`/api/Assessments/public/Outcome/${id}`)
    .then((res) => res.data)
    .catch(() => null);
};

export const getProductByIds = (ids: string[]): Promise<Product[]> => {
  const productIds = ids.join('&productIds=');
  return API.get(`/api/pricing/public/Product/list?productIds=${productIds}`).then((res) => res.data);
};

export const createLead = (lead: Lead): Promise<any> =>
  API.post('/api/store/public/Lead', lead).then((res) => res.data);

export const getLocation = (id: string): Promise<any> =>
  API.get(`/api/Assessments/public/location/questionnaire/${id}`).then((res) => res.data);

export const getLocationSearch = (locationText: string, API_KEY: string): Promise<any> => {
  const config = {
    headers: {}
  };
  return axios
    .get(`https://maps.googleapis.com/maps/api/place/details/json?place_id=${locationText}&key=${API_KEY}`, config)
    .then((res) => res.data);
};


